module.exports = __webpack_public_path__ + "img/office.facb227b.png";